import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function AboutSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);
  const { ref: contentRef, visible: contentVisible } = useScrollReveal(0.08);

  return (
    <section id="about" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div ref={titleRef} className={titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100/60 border border-secondary-200/50 mb-4">
            <i className="ri-information-line text-secondary-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-secondary-700 whitespace-nowrap">关于平台</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
            关于本站
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-8"></div>
        </div>
        <div ref={contentRef} className={contentVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-3xl mx-auto">
            触手漫画网始建于热爱与专注之上，致力于为广大漫画爱好者提供触手题材漫画的免费在线阅读服务。
            我们精心收录各类触手漫画作品，从经典长篇到新锐连载，覆盖奇幻冒险、科幻异种、都市传说等多种风格。
            采用下拉式畅快阅读模式，无需翻页即可沉浸式浏览，让每一位读者都能在这里找到心仪的触手漫画，
            享受纯粹、便捷、高品质的在线阅读体验。我们的编辑团队每日筛选优质内容，
            确保触手漫画资源的及时更新与丰富度，打造触手漫画爱好者的专属阅读乐园。
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
            {[
              { icon: 'ri-book-2-line', label: '2000+ 部作品', desc: '海量漫画资源' },
              { icon: 'ri-refresh-line', label: '每日更新', desc: '实时追更不断更' },
              { icon: 'ri-eye-line', label: '百万读者', desc: '活跃阅读社区' },
              { icon: 'ri-shield-check-line', label: '安全无广告', desc: '纯净阅读环境' },
            ].map((item, idx) => (
              <StatItem key={item.label} item={item} idx={idx} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function StatItem({ item, idx }: { item: { icon: string; label: string; desc: string }; idx: number }) {
  const { ref, visible } = useScrollReveal(0.1);

  return (
    <div
      ref={ref}
      className={`text-center ${visible ? `animate-scale-in animate-stagger-${idx + 1}` : 'animate-initial-hidden'}`}
    >
      <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
        <i className={`${item.icon} text-xl`}></i>
      </div>
      <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.label}</div>
      <div className="text-xs text-foreground-500 mt-1">{item.desc}</div>
    </div>
  );
}